// extracted by mini-css-extract-plugin
export default {"userSection":"userInfo_userSection__Mtzlb","user":"userInfo_user__41vgW","user__label":"userInfo_user__label__WJzM4","user__text":"userInfo_user__text__KA6+L"};